import { observable, action } from 'mobx'
import Api from '@api/xiao_xiong/notice'
import { SingleLoop, getMerchantInfo } from '@util'
import _get from 'lodash/get'

class NoticeStore {
  @observable unreadNoticeCount = 0
  noticeAudio
  old_notice = 0

  startGetUnreadNoticeLoop = () => {
    this.getUnreadNoticeLoop = new SingleLoop(
      'notice_count',
      this.getUnreadNotice,
      10 * 1000,
      this.onGetUnreadNotice
    )
    this.getUnreadNoticeLoop.start()
  }

  @action
  getUnreadNotice = async () => {
    let api
    let param = {
      merchant_id: getMerchantInfo().id
    }
    if (getMerchantInfo().shop_type == 5) {
      // 主商家
      api = Api.getMainNotifyUnreadCount
      param = {
        merchant_id: getMerchantInfo().id,
        user_id: getMerchantInfo().user_id
      }
    } else {
      api = Api.getNotifyUnreadCount
    }
    const { data, RetCode } = await api(param)
    if (RetCode == 4) {
      // 登录已过期，停止轮询
      this.getUnreadNoticeLoop && this.getUnreadNoticeLoop.stop()
    }
    return _get(data, 'unread', 0)
  }

  onGetUnreadNotice = count => {
    this.unreadNoticeCount = count
    if (this.unreadNoticeCount > this.old_notice) {
      // this.noticeAudio.play()
    }
    this.old_notice = count
  }

  @action
  toNotice = () => {
    if (window.location.hash.indexOf('#/localMerchant/noticeList') > -1) {
      // window.location.reload()
    } else {
      this.unreadNoticeCount = 0
      const newTab = window.open('about:blank')
      newTab.location.href = '#/localMerchant/noticeList'
    }
  }
}

export default new NoticeStore()
